import React from "react";
import { Container, Box, makeStyles, Typography } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  root: { background: theme.palette.common.black, color: "#fff" },
}));

export default function Footer() {
  const classes = useStyle();
  return (
    <Box className={classes.root}>
      <Container maxWidth="lg">
        <Box p={2} textAlign="center">
          <Typography>All Rights Reserved © 2021 bulk </Typography>
        </Box>
      </Container>
    </Box>
  );
}
